import Area from './Widgets/ArrayOfObjects/Area';
import Bar from './Widgets/ArrayOfObjects/Bar';
import BeijingLine from './Widgets/ArrayOfObjects/BeijingChart';
import CandleStick from './Widgets/ArrayOfObjects/CandleStick';
import CardsList from './Widgets/ArrayOfObjects/CardsList';
import Counter from './Widgets/ArrayOfObjects/Counter';

import CounterLine from './Widgets/ObjectofObject/CounterLine';
import CountersPie from './Widgets/ObjectofObject/CountersPie';
import CompassGuage from './Widgets/ArrayOfObjects/CompassGuage';
import Donut from './Widgets/ArrayOfObjects/Donut';
import DonutCounter from './Widgets/ArrayOfObjects/DonutCounter';
import Funnel from './Widgets/ArrayOfObjects/Funnel';
import Guage from './Widgets/ArrayOfObjects/Guage';
import GridGuage from './Widgets/ArrayOfObjects/GridGuage';
import GuageRing from './Widgets/ArrayOfObjects/GuageRing';
import GuageRingWithCounter from './Widgets/ObjectofObject/GuageRingWithCounter';
import HeatmapCalendar from './Widgets/ArrayOfObjects/HeatmapCalendar';
import ConfusionMatrix from './Widgets/ArrayOfObjects/ConfusionMatrix';
import HeatmapCartesion from './Widgets/ArrayOfObjects/HeatmapCartesion';
import ImageGalleryWithPreview from './Widgets/ArrayOfObjects/ImageGalleryWithPreview';
import Line from './Widgets/ArrayOfObjects/Line';
import LiquidGuage from './Widgets/ArrayOfObjects/LiquidGuage';
import Polar from './Widgets/ArrayOfObjects/Polar';
import Pie from './Widgets/ArrayOfObjects/Pie';
import PieRose from './Widgets/ArrayOfObjects/PieRose';
import ProgressBar from './Widgets/ArrayOfObjects/ProgressBar';
import Scatter from './Widgets/ArrayOfObjects/Scatter';
import SingleBar from './Widgets/ArrayOfObjects/SingleBar';
import StackedBar from './Widgets/ArrayOfObjects/StackedBar';
import SingleCandleStick from './Widgets/ArrayOfObjects/SingleCandleStick';
import StatusCounter from './Widgets/ArrayOfObjects/StatusCounter';

import BarTable from './Widgets/ArrayOfObjectsWithAction/BarTable';
import LineTable from './Widgets/ArrayOfObjectsWithAction/LineTable';
import PieBar from './Widgets/ArrayOfObjectsWithAction/PieBar';
import PieSingleLine from './Widgets/ArrayOfObjectsWithAction/PieSingleLine';

import SingleLineDiagram from './Widgets/Other/SingleLineDiagram';
import LineWithSelection from './Widgets/Other/LineWithSelection';
import LiveStreaming from './Widgets/Other/LiveStreaming';
import TreeGraph from './Widgets/Other/Treegraph';
import Report from './Widgets/Other/Report';
import DashboardInDash from './Widgets/Other/DashboardInDash';

import DottedBar from './Widgets/ObjectofObject/DottedBar';
import GuageLine from './Widgets/ObjectofObject/GuageLine';
import LineTableCounter from './Widgets/ObjectofObject/LineTableCounter';
import NotificationTable from './Widgets/ObjectofObject/NotificationTable';
import PieLine from './Widgets/ObjectofObject/PieLine';
import PieNestComponent from './Widgets/ObjectofObject/PieNestComponent';
import StackedLine from './Widgets/ObjectofObject/StackedLine';
import HeatmapCartesionTable from './Widgets/ObjectofObject/HeatmapCartesionTable';

import AnomalyFeedbackTable from './Widgets/Unused/AnomalyFeedbackTable';
import BoxPlot from './Widgets/Unused/BoxPlot';
import BubbleChart from './Widgets/Unused/BubbleChart';
import CandleStickBrush from './Widgets/Unused/CandleStickBrush';
import FeedbackTable from './Widgets/Unused/FeedbackTable';
import GeoMap from './Widgets/Unused/GeoMap';
import LineBarArea from './Widgets/Unused/LineBarArea';
import NotificationScatter from './Widgets/Unused/NotificationScatter';
import Regression from './Widgets/Unused/Regression';
import SelectImageDetails from './Widgets/Unused/SelectImageDetails';
import SliderStatus from './Widgets/Unused/SliderStatus';
// import SunBurst from './Widgets/Unused/SunBurst';

import TableComponent from './Widgets/Table/TableComponent';
import WindBarb from './Widgets/Table/WindBarb';

import Video from './Widgets/Unused/VideoComponent';
import Image from './Widgets/Unused/ImageComponent';
import Predictions from './Widgets/Unused/Predictions';

export {
  TableComponent,
  Guage,
  Pie,
  Polar,
  PieRose,
  Donut,
  Counter,
  CounterLine,
  CompassGuage,
  CountersPie,
  Funnel,
  Bar,
  CandleStick,
  SingleBar,
  Line,
  LineWithSelection,
  ProgressBar,
  Area,
  Regression,
  PieBar,
  BubbleChart,
  CandleStickBrush,
  TreeGraph,
  BoxPlot,
  BeijingLine,
  LiquidGuage,
  SingleCandleStick,
  BarTable,
  StatusCounter,
  Scatter,
  HeatmapCartesion,
  HeatmapCalendar,
  ConfusionMatrix,
  DottedBar,
  PieSingleLine,
  PieLine,
  FeedbackTable,
  AnomalyFeedbackTable,
  WindBarb,
  CardsList,
  StackedBar,
  StackedLine,
  HeatmapCartesionTable,
  DonutCounter,
  LiveStreaming,
  GuageRing,
  GuageRingWithCounter,
  NotificationTable,
  ImageGalleryWithPreview,
  SelectImageDetails,
  PieNestComponent,
  LineTable,
  SliderStatus,
  GuageLine,
  GridGuage,
  LineTableCounter,
  SingleLineDiagram,
  NotificationScatter,
  // SunBurst,
  LineBarArea,
  GeoMap,
  Video,
  Report,
  Image,
  Predictions,
  DashboardInDash
};
